import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'react-bootstrap'
import { Updaters } from '@leverege/api-attributes';
import { NumericInput, LabelGroup, Flex } from '~/views';
import Util from './Util'

export default class JitterEditor extends React.Component {

  static TYPE = Updaters.JitterUpdaterCreator.typeName();

  static propTypes = {
    updater : PropTypes.object,
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.changePath = Util.ChangePath.bind( this )
  }

  render() {
    const { updater } = this.props
    if ( updater == null ) {
      return <div />
    }

    return (
      <Flex variant="vSpace" direction="column" align="flex-start">
        
        <LabelGroup>
          <label>Between</label>
          <div>
            <NumericInput
              hint="From..." 
              style={{ width : '80px' }}
              size={5}
              value={updater.range1}
              float
              onChange={( v, err ) => { this.changePath( 'range1', v, err ) }} />
          
            <label style={{ padding : '0 8px' }}>and</label>
            <NumericInput
              hint="To..." 
              style={{ width : '80px' }}
              size={5}
              value={updater.range2}
              float
              onChange={( v, err ) => { this.changePath( 'range2', v, err ) }} />
          </div>
        </LabelGroup>

        <LabelGroup>
          <label>Every</label>
          <div>
            <NumericInput
              hint="Seconds..." 
              value={updater.update / 1000}
              float
              size={5}
              min={0}
              onChange={( v, err ) => { this.changePath( 'update', typeof v === 'number' ? v * 1000 : v, err ) }} />
            <label style={{ padding : '0 8px' }}>seconds</label>
          </div>
        </LabelGroup>

        <LabelGroup>
          <label />
          <Checkbox
            checked={updater.offInitial} 
            onChange={( e ) => { this.changePath( 'offInitial', e.target.checked, false ) }}>
            Off Initial Value
          </Checkbox>
        </LabelGroup>
      </Flex>
    ) 
  }
}
